export default __webpack_public_path__ + "static/media/zero_routes_image.deb896f7.svg";